import DragContainer from "lib/Draggable/DragContainer";
import { useContext } from "react";
import { TreeContext } from "pages/Editor";
import Button from "./Button";
import Heading from "./Heading";
import List from "./List";
import Map from "./Map";
import Panel from "./Panel";
import Table from "./Table";
import Div from "./Div";
import Link from "./Link";
import Input from "./Input";
import DragWrapper from "lib/Draggable/DragWrapper";

/**
 * TODO: remove
 * no ref component
 */
function Test() {
  return <div>test component</div>;
}

export function renderComponent(component, path, data) {
  if (!component) return null;
  if (component.type === "LIST") {
    const { name: type } = component;
    return <List {...{ type, path, ...data }}>{component.children}</List>;
  }
  if (component.type === "HEADING") {
    const { name, value } = component;
    return <Heading component={{ value, name }} />;
  }
  if (component.type === "BUTTON") {
    const { value } = component;
    return <Button {...{ path, value, ...data }}>{component.name}</Button>;
  }
  if (component.type === "PANEL") {
    const { name, value } = component;
    return <Panel {...{ name, value, path }}>{component.children}</Panel>;
  }
  if (component.type === "INPUT") {
    return <Input />;
  }
  if (component.type === "TEXTAREA") {
    return <textarea />;
  }
  if (component.type === "MAP") {
    return <Map />;
  }
  if (component.type === "TABLE") {
    return <Table />;
  }
  if (component.type === "LINK") {
    return <Link />;
  }
  if (component.type === "DIV") {
    return <Div>{component.children}</Div>;
  }
  // TODO: remove
  if (component.type === "TEST") {
    return <Test />;
  }
  return null;
}

/**
 * component data mapping
 * render component from data
 *
 * @param {object} props
 */
export default function Schema({ component, path, level, ...props }) {
  const { editable } = useContext(TreeContext);
  const content = renderComponent(component, path, props);
  if (content) {
    if (["DIV", "INPUT"].includes(component.type)) {
      return <DragWrapper path={path}>{content}</DragWrapper>;
    }
  }
  // component is used by some hooks
  return content ? (
    <DragContainer
      {...{ component, path, editable, draggable: editable && level !== 0 }}
    >
      {content}
    </DragContainer>
  ) : null;
}
